import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ManageNotificationLayer from "../../../components/Admin/ManageNotificationLayer";

const ManageNotification = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageNotificationLayer />
      </MasterLayout>
    </>
  );
};
export default ManageNotification
